import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Ellipse, Path } from "react-native-svg";

export const IconPreview: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPreview"><Ellipse cx="12" cy="5" rx="6.5" ry="2" stroke="currentColor"/><Path d="M18.5 9.5C18.5 10.6046 15.5899 11.5 12 11.5C8.41015 11.5 5.5 10.6046 5.5 9.5" stroke="currentColor"/><Path d="M5.5 5.00024V10.5002L3.68172 15.2276C3.24254 16.3694 3.23327 17.673 4.11923 18.5166C5.30799 19.6485 7.64028 21.0002 12 21.0002C16.3597 21.0002 18.692 19.6485 19.8808 18.5166C20.7667 17.673 20.7575 16.3694 20.3183 15.2276L18.5 10.5002V5.00024" stroke="currentColor"/></CentralIconBase>;
});

export default IconPreview;
